import { render } from "./select-delivery-method-challenge.vue?vue&type=template&id=4c933401"
import script from "./select-delivery-method-challenge.vue?vue&type=script&lang=js"
export * from "./select-delivery-method-challenge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__